import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Expertises component
 */
export default class Expertises extends Base {
  breakpoints = ['xxs', 'xs', 's', 'm'];

  /**
   * Component Configuration
   */
  static config = {
    name: 'Expertises',
    refs: ['items[]', 'contents[]', 'mobileContents[]'],
  };

  /**
   *
   */
  mounted() {
    if (!this.isMobile) {
      this.initTimeline();
    }
  }

  /**
   *
   */
  onItemsClick({ target, index }) {
    if (!this.isMobile) {
      return;
    }

    const el = this.$refs.mobileContents[index];
    const isOpen = el.clientHeight > 0;
    target.classList.toggle('is-active');

    gsap.to(el, {
      height: isOpen ? 0 : 'auto',
      duration: 0.3,
      ease: 'power4.inOut',
    });
  }

  /**
   *
   */
  initTimeline() {
    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: '+=400% top',
        pin: true,
        scrub: true,
      },
    });

    this.$refs.items.forEach((element, index) => {
      this.tl.to(element, {
        opacity: 1,
        duration: 0.4,
      });

      const prevItem = this.$refs.items[index - 1];
      if (prevItem) {
        this.tl.to(
          prevItem,
          {
            opacity: 0.3,
          },
          '<',
        );
      }
    });

    this.tlContents = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: '+=400% top',
        pin: false,
        scrub: true,
      },
    });

    this.$refs.contents.forEach((element, index) => {
      this.tlContents.to(element, {
        opacity: 1,
        y: 0,
        duration: 0.4,
      });

      const prevItem = this.$refs.contents[index - 1];
      if (prevItem) {
        this.tlContents.to(
          prevItem,
          {
            opacity: 0,
            filter: 'blur(10px)',
            scale: 0.8,
            y: 50,
            duration: 0.4,
          },
          '<',
        );
      }
    });
  }

  /**
   *
   */
  destroyed() {
    this.tl?.scrollTrigger?.kill();
    this.tl?.kill();
    this.tlContents?.scrollTrigger?.kill();
    this.tlContents?.kill();
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
